var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrlIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51770_86308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.07617 14.3295C5.2618 14.4079 5.44992 14.4807 5.6418 14.5426C5.54492 14.2463 5.52648 14.2142 5.32773 13.6157L5.07617 14.3295Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32793 14.15C9.80293 12.9594 10.1342 11.7375 10.3248 10.5H6.42793L5.6748 12.6375C6.07543 13.9188 6.12293 13.9928 6.36324 14.7306C7.26293 14.9212 8.23855 14.9216 9.13293 14.735C9.13293 14.7353 9.32793 14.15 9.32793 14.15Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.875 8C0.875 8.63719 0.967187 9.26781 1.13969 9.875H2.70937L4.3875 8.98125C4.33375 8.02812 4.36094 7.07219 4.46531 6.125H1.13719C0.9675 6.72156 0.875 7.35 0.875 8Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.878262 11.7844C0.890762 11.9094 0.978262 12.0156 1.10326 12.05C1.51951 12.1694 2.7267 12.515 3.12232 12.6278C3.23451 13.0225 3.58232 14.2353 3.70014 14.6469C3.77295 14.9325 4.20389 14.9506 4.29389 14.6656C4.87389 13.0141 5.58951 10.9922 6.16889 9.35312C6.24482 9.15843 6.08232 8.93031 5.87514 8.9375C5.77982 8.91093 1.75232 11.0975 1.04076 11.475C0.928262 11.5344 0.862637 11.6562 0.878262 11.7844Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64954 9.875H10.4089C10.5536 8.62719 10.5477 7.37063 10.4048 6.125H5.09422C4.99829 6.96375 4.96516 7.80906 4.99954 8.65313C5.24704 8.53063 5.58641 8.2925 5.87454 8.3125C6.50172 8.29844 6.98422 8.97156 6.75891 9.5625L6.64954 9.875Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12164 1.2628C8.23977 1.07999 7.25883 1.07999 6.37695 1.26312L6.16852 1.85312C5.69914 3.02968 5.37195 4.2553 5.18164 5.49999H10.321C10.1223 4.0578 9.64195 2.6403 9.12164 1.2628Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1527 10.5H10.9627C10.8055 11.85 10.3252 13.3194 9.85645 14.5437C11.8321 13.91 13.4033 12.4122 14.1527 10.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34766 5.50005H4.53766C4.69484 4.15005 5.17516 2.68036 5.64391 1.4563C3.66828 2.09005 2.09703 3.58786 1.34766 5.50005Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85059 1.45435C10.3675 2.76935 10.76 4.12372 10.9562 5.49997H14.1521C13.4021 3.58622 11.819 2.08778 9.85059 1.45435Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0352 6.125C11.1736 7.37156 11.1814 8.62812 11.0436 9.875H14.363C14.7098 8.69219 14.7098 7.30781 14.363 6.125H11.0352Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51770_86308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "current",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlIcon);
export default __webpack_public_path__ + "static/media/UrlIcon.c2d1fc8a42bfd4acd1f0824edfb67297.svg";
export { ForwardRef as ReactComponent };